export default "__VITE_ASSET__843ca539__"